import PublicHeader from "@/components/PublicHeader";
import PublicFooter from "@/components/PublicFooter";
import ChatWidget from "@/components/ChatWidget";
import Seo from "@/components/Seo";
import Editable from "@/components/Editable";
import { Quotes, Star } from "@phosphor-icons/react";

const REVIEWS = [
  { name: "The Henderson family & Milo", suburb: "Maroochydore", service: "Puppy School", quote: "the team gave us the foundation we needed with our 10-week-old pup. Six months on, Milo walks calmly on lead, settles when visitors arrive, and comes back every time he's called. The small class sizes made all the difference." },
  { name: "Marcus & Cooper", suburb: "Buderim", service: "Private Puppy Consult", quote: "Six weeks ago Cooper would lose his mind at every passing dog. Today we walk past the dog park calmly. the team didn't just train my dog — she gave me my walks back." },
  { name: "Sarah & Ziggy", suburb: "Mudjimba", service: "Puppy School", quote: "We learned so much in four weeks. The homework between classes really cemented it. Ziggy graduated knowing sit, stay, recall and loose-leash walking." },
  { name: "Pete & Daisy", suburb: "Mooloolaba", service: "Walk & Train", quote: "I work full time and was worried about Daisy getting enough enrichment. The walk and train sessions have been a game-changer — she comes home tired, happy and better-trained." },
  { name: "The Wong family & Bear", suburb: "Coolum Beach", service: "Puppy School + Private", quote: "We started in Puppy School then booked some private sessions for the trickier bits. Worth every cent. our calm, structured approach works." },
  { name: "Liam & Bella", suburb: "Eudlo", service: "Scent Detection", quote: "Bella's an old soul and the scent work has given her something to focus on. the team runs a tight, fun class. Highly recommend." },
];

export default function Testimonials() {
  return (
    <div className="min-h-screen bg-[#FDFBF7]">
      <Seo title="Reviews & Testimonials | Puppl" description="What Sunshine Coast clients say about the Puppl team's puppy training — Puppy School, Private Consults, Walk & Trains and Scent Detection reviews." canonical={typeof window !== "undefined" ? window.location.origin + "/testimonials" : ""} />
      <PublicHeader />

      <section className="bg-[#1b4a76] text-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-12 py-20 text-center">
          <Editable id="testimonials.eyebrow" as="p" className="text-sm uppercase tracking-wider font-semibold text-[#E2B054] mb-3" defaultHtml="Loved by Sunny Coasters" />
          <Editable id="testimonials.heading" as="h1" className="font-heading text-4xl lg:text-6xl font-bold leading-tight mb-3" defaultHtml="Real stories. Real puppies." />
          <Editable id="testimonials.subtitle" as="p" className="text-lg lg:text-xl opacity-90" defaultHtml="Six weeks of training. A lifetime of better behaviour." />
        </div>
      </section>

      <section className="py-16 px-6 lg:px-12 max-w-7xl mx-auto">
        <div className="grid md:grid-cols-2 gap-6">
          {REVIEWS.map((r, i) => (
            <div key={i} className="card-pp p-7" data-testid={`review-${i}`}>
              <div className="flex gap-1 mb-3">
                {[1, 2, 3, 4, 5].map((s) => <Star key={s} size={16} weight="fill" className="text-[#E2B054]" />)}
              </div>
              <Quotes size={28} weight="duotone" className="text-[#f38838] mb-3" />
              <Editable id={`testimonials.review.${i}.quote`} as="p" className="text-stone-800 leading-relaxed italic mb-5" defaultHtml={r.quote} />
              <div className="border-t border-stone-100 pt-4">
                <Editable id={`testimonials.review.${i}.name`} as="div" className="font-heading font-semibold text-stone-900" defaultHtml={r.name} />
                <Editable id={`testimonials.review.${i}.meta`} as="div" className="text-sm text-stone-500" defaultHtml={`${r.service} • ${r.suburb}`} />
              </div>
            </div>
          ))}
        </div>
      </section>

      <PublicFooter />
      <ChatWidget />
    </div>
  );
}
